module.exports = __webpack_public_path__ + "img/envelope.9fa0badf.svg";